import { CMSLink } from '@/components/Link'
import { Media } from '@/components/Media'
import RichText from '@/components/RichText'
import { cn } from '@/utilities/ui'
import { ChevronsRight } from 'lucide-react'
import Link from 'next/link'

const DefaultCard = ({
  service,
  iconPosition = 'left',
}: {
  service: any
  iconPosition?: 'right' | 'left'
}) => {
  return (
    <div className="bg-card relative border border-border rounded-xl p-7 group flex flex-col mx-2 md:mx-4 lg:mx-0">
      {/* Image Box */}
      <div className="relative block">
        <div className="relative block overflow-hidden h-[200px] sm:h-[250px] md:h-[280px] lg:h-[300px]">
          {/* Image with scale on hover */}
          <Media
            resource={service?.image}
            className="w-full h-full object-cover rounded-xl transform transition-transform duration-1000 ease-in-out group-hover:scale-[1.05]"
          />

          {/* Overlay effect */}
          <div className="absolute top-0 bottom-0 left-1/2 right-[51%] bg-muted/30 pointer-events-none transition-all duration-[400ms] ease-linear group-hover:left-0 group-hover:right-0"></div>
        </div>

        {/* Icon circle */}
        {service?.icon && (
          <div
            className={cn(
              "absolute top-5 left-5 w-24 h-24 bg-muted rounded-full flex items-center justify-center z-[2] before:content-[''] before:absolute before:inset-0 before:rounded-full before:bg-primary before:scale-0 before:origin-center before:transition-[transform] before:duration-[400ms] before:ease-out group-hover:before:scale-100",
              {
                'left-[69%] ': iconPosition === 'right',
              },
            )}
          >
            <span
              className={`relative inline-block text-4xl text-foreground transition-all duration-500 delay-100 group-hover:scale-90 group-hover:text-primary-foreground`}
            >
              <Media resource={service?.icon} className="w-full h-full" />
            </span>
          </div>
        )}
      </div>

      {/* Content */}
      <div className="relative pt-3 flex flex-col">
        {service.title && (
          <RichText
            className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-semibold mb-2 line-clamp-2 break-words text-black"
            data={service.title}
            enableGutter={false}
            enableProse={true}
          />
        )}
        {service.description && (
          <RichText
            className="text-sm sm:text-base md:text-lg text-muted-foreground mb-6 break-words flex-grow"
            data={service.description}
            enableGutter={false}
            enableProse={true}
          />
        )}

        <div className="space-y-3 mt-auto">
          {service?.links?.map((item: any, linkIndex: any) => {
            const link = item.link
            return (
              <div
                key={linkIndex}
                className="relative overflow-hidden group rounded-full inline-flex"
              >
                <CMSLink
                  {...link}
                  key={link?.id || linkIndex}
                  className="z-10 inline-flex items-center border border-primary bg-primary text-primary-foreground hover:bg-primary/90 cursor-pointer font-semibold text-base tracking-wide transition-colors duration-300 rounded-full px-6 py-8"
                  aria-label={link.label || 'Learn more about this service'}
                >
                  <div className="w-12 h-12 rounded-full flex flex-1 items-center justify-center ml-2 bg-primary text-primary-foreground">
                    <ChevronsRight />
                  </div>
                </CMSLink>
                {/* Removed hover effect */}
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default DefaultCard
